// "Answer on WhatsApp" (CMS review round 2, karim-15, nadia-09, nadia-34):
// a link a person clicks, opening WhatsApp on their own phone or computer
// with the customer's number and the case number typed in. Nothing is sent
// by Safrati. wa.me needs the number with its country code: a number typed
// without one ("03 123 456") gets no link, rather than a guessed country.

// "+961 3 123 456" / "00961 3 123 456" / "9613123456" -> "9613123456";
// null when the country code can't be read.
export function whatsappNumber(phone) {
  const text = String(phone || "").trim();
  if (!text) return null;
  const digits = text.replace(/\D/g, "");
  let international = null;
  if (text.startsWith("+")) international = digits;
  else if (digits.startsWith("00")) international = digits.slice(2);
  else if (digits.startsWith("961") && digits.length >= 10) international = digits;
  if (!international || international.length < 8 || international.length > 15 || international.startsWith("0")) return null;
  return international;
}

// The link, with "About your Safrati application #1611: " typed in; null
// without a number WhatsApp can open.
export function whatsappLink(phone, caseId) {
  const number = whatsappNumber(phone);
  if (!number) return null;
  const text = caseId ? `About your Safrati application #${caseId}: ` : "";
  return `https://wa.me/${number}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}
